import { createSlice } from "@reduxjs/toolkit";

const callSmsSlice = createSlice({
    name: "callSms",
    initialState: {
        appActivityData: null,
        callSmsDetailData: null

    },
    reducers: {
        setCallSmsData: (state, action) => {
            state.callSmsData = action?.payload
        },
        setCallSmsDetailData:(state,action) => {
            state.callSmsDetailData = action?.payload
        },
        clearCallandSms: (state, action) => {
            state.appActivityData = null
            state.callSmsDetailData = null
        }
    }
});

// this is for dispatch
export const { setCallSmsData, setCallSmsDetailData, clearCallandSms} = callSmsSlice.actions;

// this is for configureStore
export default callSmsSlice.reducer;
